<script setup>
    import { ref, onMounted, reactive } from 'vue'
    import { useNotificationStore } from '@/stores/NotificationStore.js'
    import PageBuilderView from "../page-builder-view/pageBuilderView.vue";

    const notificationStore = useNotificationStore()
    const emit = defineEmits(['editorTypeLoaded'])

    const props = defineProps({
        expertContract: {
            type: Object,
            required: true
        },
        conditions: {
            type: Object,
            required: true
        },
        signingEnabled: {
            type: Boolean,
            required: true
        },
    })

    const content = ref(null)
    const design = ref(null)
    const pageBuilderEnabled = ref(null)
    const containerRef = ref(null)
    const aiHtmlContent = ref(null)
    const aiMediaEntryMap = ref({})
    const previewing = ref(false)
    const saving = ref(false)

    const loadContent = async () => {
        const res = await axios.get(route('expert-contracts.content', props.expertContract.id))
        content.value = res.data.content
        design.value = res.data.design
        pageBuilderEnabled.value = res.data.pageBuilderEnabled,
        containerRef.value = res.data.containerRef
        aiHtmlContent.value = res.data.aiHtmlContent
        aiMediaEntryMap.value = res.data.aiMediaEntryMap ?? {}

        emit(
            'editorTypeLoaded',
            aiHtmlContent.value ? 'closer' : pageBuilderEnabled.value ? 'page-builder' : 'block-editor'
        )
    }

    const saveContent = async () => {
        saving.value = true
        const res = await axios.put(route('expert-contracts.content.update', props.expertContract.id), {
            title: props.expertContract.title,
            block_editor_content: content.value,
        })
        saving.value = false

        notificationStore.addNotification({
            type: 'success',
            title: _mft('shared:save.changesSaved'),
            dismissAfter: 2500,
        })
    }

    onMounted(() => {
        loadContent()
    })

</script>
<template>
    <div>
        <div v-if="!props.signingEnabled && !conditions.has_signed_signature_requests && !previewing">
            <div v-if="aiHtmlContent">
                <div class="mt-4 overflow-hidden shadow-sm">
                    <ai-page-builder-renderer
                        :html-content="aiHtmlContent"
                        :media-entry-map="aiMediaEntryMap"
                        :container-ref="containerRef"
                    ></ai-page-builder-renderer>
                </div>
            </div>
            <div v-else-if="! pageBuilderEnabled">
                <input-expert-contract-editor
                    name="block_editor_content"
                    v-model:content="content"
                ></input-expert-contract-editor>
            </div>
            <div v-else>
                <div
                    class="flex"
                    :class="content.length === 0 ? 'justify-center flex-col items-center' : 'justify-end'"
                >
                    <span
                        v-if="content.length === 0"
                        class="italic text-center my-4"
                    >
                        {{ _mft('expertContract:contentEditor.noContentYet')}}
                    </span>
                </div>
                <div class="mt-4">
                    <page-builder-view
                        :content="content"
                        :design="design"
                        :container-ref="containerRef"
                    ></page-builder-view>
                </div>
            </div>

            <div id="teleport-target-block-editor-toolbar" class="pb-24 md:ml-4"></div>
        </div>

        <div v-if="props.signingEnabled || conditions.has_signed_signature_requests || previewing">
            <div class="mt-2">
                <iframe
                    :src="route('expert-contracts.showPreview', props.expertContract.id)"
                    class="w-full h-[900px] border-t"
                ></iframe>
            </div>
        </div>
    </div>
</template>
